import React from "react";

/** Shield-check — Lucide/Figma, outer 40×40 to match WhoIsICMFor icons */
const ShieldCheckIcon = ({ className, ...rest }: React.SVGProps<SVGSVGElement>) => {
    return (
        <span className="relative inline-block size-10 shrink-0 overflow-hidden" aria-hidden>
            <span className="absolute inset-[12.5%]">
                <svg
                    className={className ?? "block size-full"}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...rest}
                >
                    <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="m9 12 2 2 4-4"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    );
};

export default ShieldCheckIcon;
